<template>
    <div class="price3">
        <div class="banner outer">
            <div class="title_box inside1490">
                <div class="ban_left">
                    <h1>易猎招聘管理系统</h1>
                    <p>助力企业人力资源数字化转型</p>
                </div>
                <div class="ban_right">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/pic_new01%402x.png"/>
                </div>
            </div>
        </div>
        <!--切换-->
        <div class="tab_box outer">
            <div class="tab_container inside1490">
                <span class="tab_child" @click="()=>tabindex=1" :style="{color:tabindex==1?'#0084FF':'#7087A6'}" >
                    RPO招聘管理系统
                    <span v-show="tabindex==1" class="active_in"></span>
                    <span v-show="tabindex==1" class="triangle"></span>
                </span>
                <span  class="tab_child" @click="()=>tabindex=2" :style="{color:tabindex==2?'#0084FF':'#7087A6'}">
                    HR招聘管理系统
                    <span v-show="tabindex==2" class="active_in"></span>
                    <span v-show="tabindex==2" class="triangle"></span>
                </span>
            </div>
        </div>
        <pricetwo v-if="tabindex==1"></pricetwo>
        <pricehr v-if="tabindex==2"></pricehr>
        <!-- <div class="apply outer">
            <div class="inside trial">
                <h2>即刻开启数字化招聘人效提升之旅</h2>
                <p @click="trial('')">申请试用</p>
            </div>
        </div> -->
        <div class="security outer">
          <div class="inside1490 security_child">
            <div class="security_left"><img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_customer_service%402x.png"/></div>
            <div class="security_right">
              <p class="p1">即刻开启数字化招聘人效提升之旅</p>
              <!-- <div class="security_center" @click="trial()">申请试用</div> -->
            </div>
           
          </div>
      </div>
       <!--申请试用组件-->
    <populone :isshow="windowflags" :he="true" @handleChange="changewindow" />
    </div>
</template>
<script>
import populone from "@/components/views/popul/populone";
import pricehr from "../price/pricehr.vue"
import pricetwo from "../price/pricetwo.vue"
export default {
    name: "price",
    data(){
        return{
            tabindex:1,
            selectId:'',
            windowflags: false,
            routeData:{},
          
        }
    },
    metaInfo: {
      title: '易猎云产品价格-更适合RPO批量招聘场景的免费招聘系统',
      meta: [
        {
          name: 'keywords',
          content: '易猎云产品价格，产品报价，招聘管理系统，免费，free，批量招聘，数字化'
        },
        {
          name: 'description',
          content: '易猎云招聘管理系统产品价格，RPO公司批量招聘数字化首选的招聘系统'
        }
      ]
    },
    mounted(){
        if (Object.keys(this.$route.query).length) {
          this.routeData = this.$route.query;
        }
        const { u = "" } = this.routeData;
        if (!u) {
        console.log("官网价格");
        zhuge.track("官网价格页", {
            渠道: "pc",
            utm类型: "自然流量",
        });
        } else {
        zhuge.track("官网价格页", {
            渠道: "pc",
            utm类型: "驱动流量",
        });
        }
    },
    components: {
        populone,
        pricehr,
        pricetwo
    },
    methods: {
        trial(id) {
            this.windowflags = true;
        },
        changewindow(value) {
            this.windowflags = value;
        },
    }
}
</script>
<style lang="less" scoped>
@import "~@/assets/css/style/index.less";
.price3{
    margin-top: 85px;
    .banner{
        display: flex;
        position: relative;
        width: 100%;
        height: 325px;
        background: #f4f9fe;
        .title_box{
            display: flex;
            .ban_left{
                width: 810px;
                h1{
                    font-size: 42px;
                    margin-top: 86px;
                }
                p{
                    font-size: 30px;
                    margin-top: 60px;
                    margin-left: 116px;
                }
            }
            .ban_right{
                flex: 1;
                img{
                    width: 453px;
                    height: 241px;
                    margin-top: 50px;
                }
            }
        }
    }
    .tab_box{
        width: 100%;
        height: 50px;
        background: #f4f9fe;
        .tab_container{
            height: 50px;
            display: flex;
            border-bottom: solid 1px #DBE2F2;
            padding: 0 200px;
            .tab_child{
                display: inline-block;
                position: relative;
                flex: 1;
                text-align: center;
                line-height: 40px;
                color: #7087A6;
                font-size: 24px;
                font-weight: 600;
                cursor: pointer;
                .active_in{
                    position: absolute;
                    display: inline-block;
                    width: 125px;
                    height: 3px;
                    background: #377BF5;
                    left: 207px;
                    top: 48px;
                }
                .triangle{
                    position: absolute;
                    display: inline-block;
                    width: 0px;
                    height: 0px;
                    border: 10px solid transparent;
                    border-top-color: #377BF5;
                    top: 48px;
                    left: 260px;
                    z-index: 9;
                }
            }
        }
    }
   .apply {
        width: 100%;
        height: 410px;
        background-image: url("https://img.yilieyun.com/oss/ylyofficialWebImagse/bg_blue_02@2x.jpg");
        background-repeat: no-repeat;
        background-size: 105%;
        padding-top: 119px;

        h2 {
        font-size: 50px;
        text-align: center;
        color: #ffffff;
        line-height: 70px;
        }

        p {
        width: 158px;
        height: 66px;
        background: #ffffff;
        border-radius: 7px;
        color: #0084ff;
        line-height: 66px;
        text-align: center;
        font-size: 24px;
        margin: 0 auto;
        margin-top: 53px;
        cursor: pointer;
    }
  }
  .security{
      width: 100%;
      height: 277px;
      background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/bg_01%402x.png');
      background-repeat: no-repeat;
      background-size: 100% 102%;
      padding-top: 53px;
      box-sizing: border-box;
      .security_child{
        display: flex;
        .security_left{
            margin-left: 197px;
              img{
                width: 145px;
                height: 128px;
              }
        }
        .security_right{
             margin-left: 37px;
              .p1{
              display: inline-block;
              font-size: 48px;
              font-weight: 500;
              color: #ffffff;
              text-align: left;
              margin-top: 47px;
          }
        }
        .security_center{
          width: 158px;
          height: 60px;
          background: #FFFFFF;
          border-radius: 7px;
          line-height: 60px;
          text-align: center;
          font-size: 24px;
          color: #215FFF;
          cursor: pointer;
          margin: 0 auto;
          margin-top: 40px;
        }
      }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/price/price.vue